<script>
    // @ts-nocheck
    import { TabSetX as TabSet } from '$lib/components/UI/'
    import FacturasSiniestroSection from './FacturasSiniestroSection.svelte'
</script>

<div class="container">
    <TabSet.Group>
        <TabSet.Tab label="Facturadas">
            <FacturasSiniestroSection
                customFilter={(item) =>
                    !['Rechazada', 'A Completar'].includes(item.state)}
            />
        </TabSet.Tab>
        <TabSet.Tab label="A completar">
            <FacturasSiniestroSection
                maskState={{Rechazada: 'Factura error'}}
                customFilter={(item) =>
                    ['Rechazada', 'A Completar'].includes(item.state) &&
                    (item.state == 'Rechazada' ? !item.reemplazada : true)}
            />
        </TabSet.Tab>
        <TabSet.Tab label="Rechazadas">
            <FacturasSiniestroSection
                customFilter={(item) =>
                    item.state == 'Rechazada' && item.reemplazada}
            />
        </TabSet.Tab>
    </TabSet.Group>
</div>

<style>
    .container {
        width: 100%;
        padding: 50px 70px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        position: relative;
    }
</style>
